import {
  Button,
  Dropdown,
  Icon,
  List,
  Menu,
  Row,
  Col,
  Tag,
  Popconfirm,
  Typography,
  Input,
  Select
} from "antd";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import ExpandableCard from "../general/ExpandableCard/ExpandableCard";
import { showSuccessToast } from "../general/ToastHelper";
import history from "../../utils/history";
import { handleError } from "../../utils/ErrorHandlers";
import "./AccountsList.css";
import { Translation } from "react-i18next";
import i18next from "i18next";
import { da, tr } from "date-fns/locale";
const { Text } = Typography;

const InputGroup = Input.Group;
const { Option } = Select;

class AccountsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      showForm: false,
      account: null,
      showInnerCard: false,
      data: [],
      privilegesList: this.props.context.user.privilegesList,
      filteredData:[],
      selectedSearchKey:"accountContactEmail",
      searchValue:""
    };
  }

  componentDidMount() {
    if (this.props.data) {
      let { data } = this.props;
      this.setState({ data });
    }
  }

  handleSearch(value,searchKey){

    this.setState({searchValue:value})
    let filtered = this.props.data;
    
    if(searchKey=="accountContactEmail"){
      filtered = this.props.data.filter((element)=>{
        return  element.accountContactEmail.includes(value)
      });
    }else if(searchKey=="contactNumber"){
      filtered = this.props.data.filter((element)=>{
        return  element.accountContactNumber.includes(value)
      });
    }else if(searchKey=="IVRNumber"){
      filtered = this.props.data.filter((element)=>{
        return  element.cfg.account_numbers.some(num => 
          num.includes(value)
        ) 
      });
    }else if(searchKey=="pkgName"){
      filtered = this.props.data.filter((element)=>{
        return  element.cfg.pkg_name.includes(value)
      });
    }else if(searchKey=="accountStatus"){
      filtered = this.props.data.filter((element)=>{
        let status = element.accountStatus == "ACT" ? "active" : "suspended"
         return  status.toLowerCase().includes(value.toLowerCase())
      });
    
    }else {
      filtered = this.props.data.filter((element)=>{
        return  element.billingRef.includes(value)
      });
    }
  
    if(value ==""){
      this.setState({data:this.props.data})
    }else{
      this.setState({data:filtered})

    }

  }

  editAccount(account) {
    history.push(`/home/accounts/edit/${account}`);
  }
  viewAccount(account) {
    history.push(`/home/accounts/view/${account}`);
  }
  viewUsers(account) {
    history.push(`/home/accounts/users/${account}`);
  }
  addAdmin(account) {
    history.push(`/home/accounts/admin/create/${account}`);
  }
  manageAccountNumber(account) {
    history.push(`/home/accounts/manageAccountNumbers/${account}`);
  }

  
  renderAccountDropdown(account) {
    const menu = (
      <Menu>
        <Menu.Item
          onClick={() => this.addAdmin(account.accountId)}
          style={{
            display: this.state.privilegesList.includes("CREATE.ACCOUNT.ADMIN")
              ? "block"
              : "none",
          }}
        >
          {/* <Link to={`/edit/${account.accountId}`}> */}
          <span>{i18next.t("Add Admin")}</span>
          <Icon className={"edit-account-style"} type="plus-circle" />
          {/* </Link> */}
        </Menu.Item>
        <Menu.Item
          onClick={() => this.viewUsers(account.accountId)}
          style={{
            display: this.state.privilegesList.includes("LIST.ACCOUNT.USERS")
              ? "block"
              : "none",
          }}
        >
          <span>{i18next.t("View Users")}</span>
          <Icon className={"view-details-style"} type="user" />
        </Menu.Item>
        <Menu.Item
          onClick={() => this.editAccount(account.accountId)}
          style={{
            display: this.state.privilegesList.includes("UPDATE.ACCOUNT")
              ? "block"
              : "none",
          }}
        >
          {/* <Link to={`/edit/${account.accountId}`}> */}
          <span>{i18next.t("Edit Account")}</span>
          <Icon className={"edit-account-style"} type="edit" />
          {/* </Link> */}
        </Menu.Item>

        <Menu.Item
          onClick={() => this.manageAccountNumber(account.accountId)}
          style={{
            display: this.state.privilegesList.includes("ADD.BIVR.NUMBERS")
              ? "block"
              : "none",
          }}
        >
          {/* <Link to={`/edit/${account.accountId}`}> */}
          <span>{i18next.t("Manage Business IVR Numbers")}</span>
          <Icon className={"edit-account-style"} type="edit" />
          {/* </Link> */}
        </Menu.Item>
        <Menu.Item
          style={{
            display: this.state.privilegesList.includes("DELETE.ACCOUNT")
              ? "block"
              : "none",
          }}
        >
          <Popconfirm
            title={i18next.t("Are you sure delete this Account?")}
            onConfirm={() => this.deleteAccount(account.accountId)}
            okText={i18next.t("Yes")}
            cancelText={i18next.t("No")}
          >
            <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
              {i18next.t("Delete Account")}
              <Icon className={"delete-account-style"} type="delete" />
            </a>
          </Popconfirm>
        </Menu.Item>
        <Menu.Item
          onClick={() => this.viewAccount(account.accountId)}
          style={{
            display: this.state.privilegesList.includes("VIEW.ACCOUNT")
              ? "block"
              : "none",
          }}
        >
          <span>{i18next.t("View Details")}</span>
          <Icon className={"view-details-style"} type="eye" />
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={account} type="more" />
        </Button>
      </Dropdown>
    );
  }

  renderDetails(item) {
    return (
      <Translation>
        {(t) => (
          <Row
            style={{
              backgroundColor: "#ececec",
              padding: "10px 10px 10px 20px",
              borderBottomRightRadius: "6px",
              borderBottomLeftRadius: "6px",
            }}
          >
            <Col xs={24} lg={12}>
              <Col xs={24} lg={6}>
                <Text className="small-text m-2">{t("Account ID:")}</Text>
              </Col>
              <Col xs={24} lg={6}>
                <Tag className="m-2">{item.accountId}</Tag>
              </Col>
            </Col>
            {/* <Col xs={24} lg={12}>
              <Col xs={24} lg={6}>
                <Text className="small-text">{t("Contact Name:")}</Text>
              </Col>
              <Col xs={24} lg={6}>
                <Tag className="m-2">{item.accountContactName}</Tag>
              </Col>
            </Col> */}
            <Col xs={24} lg={12}>
              <Col xs={24} lg={6}>
                <Text className="small-text m-2">{t("Contact Email:")}</Text>
              </Col>
              <Col xs={24} lg={6}>
                <Tag className="m-2">{item.accountContactEmail}</Tag>
              </Col>
            </Col>
            <Col xs={24} lg={12}>
              <Col xs={24} lg={6}>
                <Text className="small-text m-2">{t("Contact Number:")}</Text>
              </Col>
              <Col xs={24} lg={6}>
                <Tag className="m-2">
                  {item.accountContactNumber === "" ||
                  item.accountContactNumber == null
                    ? item.accountName
                    : item.accountContactNumber}
                </Tag>
              </Col>
            </Col>
            <Col xs={24} lg={12}>
              <Col xs={24} lg={6}>
                <Text className="small-text m-2">{t("Account status:")}</Text>
              </Col>
              {item.accountStatus === "ACT" ? (
                <Col xs={24} lg={6}>
                  <Tag className="m-2">{t("Active")}</Tag>
                </Col>
              ) : (
                <Col xs={24} lg={6}>
                  <Tag className="m-2">{t("Suspended")}</Tag>
                </Col>
              )}
            </Col>
            <Col xs={24} lg={12}>
              <Col xs={24} lg={6}>
                <Text className="small-text m-2">{t("Current Package Code:")}</Text>
              </Col>
              <Col xs={24} lg={6}>
                <Tag className="m-2">{item.cfg.pkg_name}</Tag>
              </Col>
            </Col>
            <Col xs={24} lg={12}>
              <Col xs={24} lg={6}>
                <Text className="small-text-special m-2">
                  {t("Max Agents Number:")}
                </Text>
              </Col>
              <Col xs={24} lg={6}>
                <Tag className="m-2">{item.cfg.agents_max_num}</Tag>
              </Col>
            </Col>

            <Col xs={24} lg={12}>
              <Col xs={24} lg={6}>
                <Text className="small-text-special m-2">
                  {t("Max Concurrent Calls:")}
                </Text>
              </Col>
              <Col xs={24} lg={6}>
                <Tag className="m-2">{item.cfg.max_concurrent_calls}</Tag>
              </Col>
            </Col>
            <Col xs={24} lg={12}>
              <Col xs={24} lg={6}>
                <Text className="small-text-special m-2">{t("Account Numbers:")}</Text>
              </Col>
              <Col xs={24} lg={6}>
                <div>
                  {item.cfg.account_numbers.map((tag, index) => {
                    return <Tag key={tag}>{tag}</Tag>;
                  })}
                </div>
                {/* <Tag className="m-2">{item.cfg.account_numbers}</Tag> */}
              </Col>
            </Col>
            {item.billingRef !== null ? (
              <Col xs={24} lg={12}>
                <Col xs={24} lg={6}>
                  <Text className="small-text m-2">{t("Billing Id:")}</Text>
                </Col>
                <Col xs={24} lg={6}>
                  <Tag className="m-2">{item.billingRef}</Tag>
                </Col>
              </Col>
            ) : (
              <></>
            )}
          </Row>
        )}
      </Translation>
    );
  }

  async deleteAccount(Account) {
    try {
      this.acc = new AccountService();

      let data = await this.acc.deleteAccount(
        this.props.context.session_id,
        Account
      );
      showSuccessToast(i18next.t("Account deleted successfully"));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  handleRefresh() {
    this.setState({ isFetching: true });
    this.props.onRefresh();
  }

  // editAccount(Account) {
  //   this.acc = new AccountService();
  //   this.setState({ showForm: true, account: Account });
  // }

  showInnerCard(showInnerCard) {
    this.setState({ showInnerCard: !showInnerCard });
  }
  handleChange(value) {
    this.setState({selectedSearchKey:value})
    this.handleSearch(this.state.searchValue,value)
  }

  render() {
    let { data } = this.state;
    return (
      <>
 
        <InputGroup
          className="search"
          compact
          style={
            this.props.context.curr_lang === "en"
              ? { transform: "translate(68.8%, -50px)", position: "static" }
              : { transform: "translate(-68.1%, 110px)", position: "static" }
          }>
            <Select   style={{ width: '10%' }} defaultValue={this.state.selectedSearchKey} onChange={(e)=>{this.handleChange(e)}}>
            <Option value="accountContactEmail">{ i18next.t("Contact Email")}</Option>
            <Option value="contactNumber">{ i18next.t("Contact Number")}</Option>
            <Option value="IVRNumber">{i18next.t("B.IVR Numbers")}</Option>
            <Option value="pkgName">{i18next.t("Package Code")}</Option>
            <Option value="accountStatus">{i18next.t("Account Status")}</Option>
            <Option value="billingRef">{i18next.t("Billing ID")}</Option>

          </Select>
          <Input placeholder= {i18next.t("Search")} style={{ width: '20%' , height: '40px' }} onChange={(e) => {
        this.handleSearch(e.target.value,this.state.selectedSearchKey);
      } } />
        </InputGroup>      
    
      <List
          dataSource={data}
          // current={2}
          // total={8}
          // pagination={true}
          renderItem={(item) => {
            return (
              <ExpandableCard
                title={item.accountName}
                renderDropDown={this.renderAccountDropdown(item)}
                renderDetails={this.renderDetails(item)}
                showCaretIcon={false}
                status={item.accountStatus} />

            );
          } } /></>
     
      
    );
  }
}

export default withSharedStateConsumer(withRouter(AccountsList));
